import axios from "../../config/axiosConfig";
import { IMPORT_DATA_REQUEST, IMPORT_DATA_SUCCESS, IMPORT_DATA_REQUEST_FAILURE } from "../types";
import { MODULE_IDS } from '@/components/PermissionsContext';
import { getMasterOptions, getAccountMasterOptions } from './master-options-actions';

export const importMastersData = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/masters", formData,
        { params: {
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getMasterOptions(MODULE_IDS.ITEM));
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import masters data failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importPurchaseBillsData = (bookId, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/purchase-bills", formData,
        { params: {
            bookId,
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getMasterOptions(MODULE_IDS.ITEM));
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import purchase bills failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importSalesBillsData = (bookId, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/sales-bills", formData,
        { params: {
            bookId,
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getMasterOptions(MODULE_IDS.ITEM));
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import sales bills failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importGeneralPurchaseBillsData = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/general-purchase-bills", formData,
        { params: {
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getMasterOptions(MODULE_IDS.ITEM));
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import general purchase bills failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importDrCrDiscountData = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/dr-cr-note-discount", formData,
        { params: {
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getMasterOptions(MODULE_IDS.ITEM));
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import Debit/Credit Note(Discount) failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importDrCrIntrestData = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/dr-cr-note-intrest", formData,
        { params: {
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getMasterOptions(MODULE_IDS.ITEM));
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import Debit/Credit Note(Intrest) failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importSalesOutstandingData = (bookId, itemId, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/sales-outstanding", formData,
        { params: {
            bookId,
            itemId,
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import sales outstanding failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importPurchaseOutstandingData = (bookId, itemId, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/purchase-outstanding", formData,
        { params: {
            bookId,
            itemId,
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import purchase outstanding failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importGeneralPurchaseOutstandingData = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/general-purchase-outstanding", formData,
        { params: {
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import general purchase outstanding failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importDebitCreditNoteIntOutstandingData = (itemId, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/dr-cr-note-outstanding", formData,
        { params: {
            itemId: itemId,
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getAccountMasterOptions(true));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import debit/credit note(Intrest) outstanding failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const importGrayProductionData = (bookId, machineId, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_DATA_REQUEST });
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));

      return axios.post("/import-data/gray-production", formData,
        { params: {
            bookId,
            machineId,
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_DATA_SUCCESS });
            dispatch(getMasterOptions(MODULE_IDS.ITEM));
            return response.data;
          } else {
            dispatch({
              type: IMPORT_DATA_REQUEST_FAILURE,
              error: "Import gray production failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_DATA_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};